import {
    BodyCreateReplyApiV1CollaborationAppReplyPost,
    BodyCreateThreadApiV1ChatAppThreadPost,
    BodyRateReplyApiV1ChatAppReplyReplyIdRatePost,
    RateReplyApiV1ChatAppReplyReplyIdRatePostParams,
    ReplyCostApiV1CollaborationAppReplyCostGetParams,
    ReplyCostOutputDTO,
    ReplyDeleteOutputDTO,
    ReplyDTO,
    ReplyListApiV1ChatAppReplyGetParams,
    ReplyListOutputDTO,
    TelegramConnectAssistantModel,
    ThreadArchiveApiV1ChatAppThreadThreadIdArchivePostParams,
    ThreadArchiveModel,
    ThreadConnectAssistantApiV1ChatAppThreadThreadIdConnectAssistantPostParams,
    ThreadDeleteApiV1ChatAppThreadThreadIdDeleteParams,
    ThreadDeleteOutputDTO,
    ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
    ThreadDTO,
    ThreadListApiV1ChatAppThreadGetParams,
    ThreadListOutputDTO,
    ThreadUpdateRequestModel,
    UpdateThreadApiV1ChatAppThreadThreadIdPutParams,
    UserWalletDTO,
} from '../swagger/dto'
import { deleteRequest, getRequest, patchRequest, postRequest } from './config'
import { REPLY_URL, THREAD_URL, WALLET_URL } from './endpoints.constants'

export const getRequestList = async (
    params?: ThreadListApiV1ChatAppThreadGetParams,
): Promise<ThreadListOutputDTO> => {
    const response = await getRequest<ThreadListOutputDTO>(THREAD_URL, params)

    return response.data
}
export const getRequestDetail = async (
    params: ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
): Promise<ThreadDTO> => {
    const response = await getRequest<ThreadDTO>(`${THREAD_URL}/${params.threadId}`)

    return response.data
}

export const getSharedThread = async (
    params: ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
): Promise<ThreadDTO> => {
    const response = await getRequest<ThreadDTO>(`${THREAD_URL}/${params.threadId}/share`)

    return response.data
}

export const getReplyList = async (
    params?: ReplyListApiV1ChatAppReplyGetParams,
): Promise<ReplyListOutputDTO> => {
    const response = await getRequest<ReplyListOutputDTO>(REPLY_URL, params)
    return response.data
}

export const getReplyCost = async (
    params: ReplyCostApiV1CollaborationAppReplyCostGetParams,
): Promise<ReplyCostOutputDTO[]> => {
    const response = await postRequest<ReplyCostOutputDTO[]>(
        `${REPLY_URL}/cost`,
        params,
    )

    return response.data
}

export const getSharedReplyList = async (
    params?: ReplyListApiV1ChatAppReplyGetParams,
): Promise<ReplyListOutputDTO> => {
    const response = await getRequest<ReplyListOutputDTO>(`${REPLY_URL}/share`, params)
    return response.data
}

export const postReply = async (
    payload: BodyCreateReplyApiV1CollaborationAppReplyPost,
    min_balance: number,
): Promise<ReplyDTO> => {
    const response = await postRequest<BodyCreateReplyApiV1CollaborationAppReplyPost, ReplyDTO>(
        `${REPLY_URL}?min_balance=${min_balance}`,
        payload,
    )

    return response.data
}

export const postRateReply = async (
    params: RateReplyApiV1ChatAppReplyReplyIdRatePostParams,
    payload: BodyRateReplyApiV1ChatAppReplyReplyIdRatePost,
): Promise<ReplyDTO> => {
    const response = await postRequest<BodyRateReplyApiV1ChatAppReplyReplyIdRatePost, ReplyDTO>(
        `${REPLY_URL}/${params.replyId}/rate`,
        payload,
    )

    return response.data
}

export const deleteReply = async (params: number[]): Promise<ThreadDTO> => {
    const response = await patchRequest<number[], ReplyDeleteOutputDTO>(
        `${REPLY_URL}/delete_by_list`,
        params,
    )

    return response.data
}

export const deleteHardReply = async (params: number[]): Promise<ThreadDTO> => {
    const response = await patchRequest<number[], ReplyDeleteOutputDTO>(
        `${REPLY_URL}/hard_delete`,
        params,
    )

    return response.data
}

export const removeReturnReply = async (params: number): Promise<ThreadDTO> => {
    const response = await patchRequest<number, ReplyDeleteOutputDTO>(
        `${REPLY_URL}/${params}/recover`,
        params,
    )

    return response.data
}

export const postThead = async (
    payload: BodyCreateThreadApiV1ChatAppThreadPost,
    params: { min_balance?: number },
): Promise<ThreadDTO> => {
    const response = await postRequest<BodyCreateThreadApiV1ChatAppThreadPost, ThreadDTO>(
        `${THREAD_URL}?min_balance=${params.min_balance}`,
        payload,
    )

    return response.data
}

export const patchThead = async (
    params: UpdateThreadApiV1ChatAppThreadThreadIdPutParams,
    payload: ThreadUpdateRequestModel,
): Promise<ThreadDTO> => {
    const response = await patchRequest<ThreadUpdateRequestModel, ThreadDTO>(
        `${THREAD_URL}/${params.threadId}`,
        payload,
    )

    return response.data
}

export const changeTheadAssistant = async (
    params: ThreadConnectAssistantApiV1ChatAppThreadThreadIdConnectAssistantPostParams,
    payload: TelegramConnectAssistantModel,
): Promise<ThreadDTO> => {
    const response = await postRequest<TelegramConnectAssistantModel, ThreadDTO>(
        `${THREAD_URL}/${params.threadId}/connect_assistant`,
        payload,
    )

    return response.data
}

export const getWallet = async (): Promise<UserWalletDTO> => {
    const response = await getRequest<UserWalletDTO>(WALLET_URL)
    return response.data
}

export const deleteThread = async (params: ThreadDeleteApiV1ChatAppThreadThreadIdDeleteParams) => {
    const response = await deleteRequest<ThreadDeleteOutputDTO>(`${THREAD_URL}/${params.threadId}`)
    return response.data
}

export const archiveThread = async (
    params: ThreadArchiveApiV1ChatAppThreadThreadIdArchivePostParams,
    data: ThreadArchiveModel,
) => {
    const response = await postRequest<ThreadArchiveModel, ThreadDTO>(
        `${THREAD_URL}/${params.threadId}/archive`,
        data,
    )
    return response.data
}
